import type { SupportedLanguageKey } from '../languages';
import { useLocale } from './use-locale.hook';

export const useLanguage = () => useLocale().language as SupportedLanguageKey;
